import { EventEmitter, OnInit } from '@angular/core';
import { LivePreviewService } from '../../shared/services/live-preview.service';
import { LeadGenerationStylesService } from '../../shared/services/lead-generation-styles.service';
import { AmplitudeService } from '../../../shared/services/amplitude.service';
import { ToastrService } from 'ngx-toastr';
import { getActiveProjectSelector } from '../../projects/projects.reducer';
import { Store } from '@ngrx/store';
import { UpdateProjectStyleAction } from '../../projects/projects.action';
import { MatDialog } from '@angular/material';
import { InfoDialogComponent } from '../../../shared/dialog/info-dialog/info-dialog.component';
import { ConfirmDialogComponent } from '../../../shared/dialog/confirm-dialog/confirm-dialog.component';
var PopupCreatorComponent = /** @class */ (function () {
    function PopupCreatorComponent(livePreviewService, leadGenerationStylesService, amplitudeService, toastr, store, dialog) {
        this.livePreviewService = livePreviewService;
        this.leadGenerationStylesService = leadGenerationStylesService;
        this.amplitudeService = amplitudeService;
        this.toastr = toastr;
        this.store = store;
        this.dialog = dialog;
        this.insertHtml = new EventEmitter();
        this.amplitudeService.logEvent('Panel: Page View: Lead Generation Pop-up Editor');
    }
    PopupCreatorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.popupSettings = this.leadGenerationStylesService.createPopUpForm();
        this.store.select(getActiveProjectSelector).subscribe(function (config) {
            _this.config = config;
            _this.leadGenerationStylesService.updateForm(_this.popupSettings, _this.config, 'popup');
            _this.advancedSettings = _this.config.popupStyle.custom.advanced;
        });
        this.popupSettings.valueChanges.subscribe(function () { return _this.sendChanges(); });
        this.popupSettings.get('advanced').valueChanges.subscribe(function (value) {
            _this.advancedSettings = value;
        });
        this.isPopup = true;
    };
    Object.defineProperty(PopupCreatorComponent.prototype, "currentProjectId", {
        get: function () {
            return this.config.projectId;
        },
        enumerable: true,
        configurable: true
    });
    PopupCreatorComponent.prototype.sendChanges = function () {
        this.livePreviewService.sendToFrame('CHANGE_SETTINGS', this.popupSettings.value, undefined);
    };
    PopupCreatorComponent.prototype.isIncorrectCustomHTML = function () {
        var htmlToCheck = document.createElement('html');
        htmlToCheck.innerHTML = this.popupSettings.get('customHTML').value;
        return ['input.cc-number-input', 'button.cc-button', 'div.cc-error-message'].some(function (selector) { return htmlToCheck.querySelectorAll(selector).length === 0; });
    };
    PopupCreatorComponent.prototype.saveDb = function () {
        var _this = this;
        if (this.advancedSettings && this.isIncorrectCustomHTML()) {
            this.dialog.open(InfoDialogComponent, {
                data: {
                    title: 'LEAD_GENERATION.INCORRECT_HTML_TITLE',
                    body: 'LEAD_GENERATION.INCORRECT_HTML_INFO'
                }
            });
            return;
        }
        this.dialog
            .open(ConfirmDialogComponent, {
            data: {
                title: 'LEAD_GENERATION.CONFIRMATION_TITLE',
                body: 'LEAD_GENERATION.CONFIRMATION_POPUP_INFO'
            }
        })
            .afterClosed()
            .subscribe(function (confirm) {
            if (confirm) {
                _this.amplitudeService.logEvent('Panel: Lead Generation: Pop-up Published');
                _this.store.dispatch(new UpdateProjectStyleAction({ type: 'POPUP', body: _this.popupSettings.value, config: _this.config }));
            }
        });
    };
    PopupCreatorComponent.prototype.handleAdvancedSettingsClick = function () {
        this.popupSettings.get('advanced').setValue(!this.popupSettings.get('advanced').value);
        window.scroll(0, 0);
    };
    PopupCreatorComponent.prototype.onChangeEditorCode = function (code, formField) {
        this.popupSettings.get(formField).setValue(code);
    };
    PopupCreatorComponent.prototype.onChangePreviewType = function (isPopup) {
        this.isPopup = isPopup;
    };
    PopupCreatorComponent.prototype.addInput = function () {
        this.insertHtml.next('<input type="text" class="cc-number-input"/>');
    };
    PopupCreatorComponent.prototype.addButton = function () {
        this.insertHtml.next('<button class="cc-button">Ok</button>');
    };
    PopupCreatorComponent.prototype.addDiv = function () {
        this.insertHtml.next('<div class="cc-error-message">Not valid phone number</div>');
    };
    return PopupCreatorComponent;
}());
export { PopupCreatorComponent };
